import React, { useState } from "react";
import { toast } from "react-toastify";
import NumberField from "../../../Components/NumberField";
import Handler from "../../../Helpers/Handler";
import { firstError, fuelRowsErrors, invalidClass, odometerError, RULES } from "../../../Helpers/bookingRules";


const StartTripModal = ({ bookingId, fuelTypes, onClose, onStarted , currentKm }) => {
    const [startKm, setStartKm] = useState("");
    const [startFuel, setStartFuel] = useState(() =>
        (fuelTypes?.length ? fuelTypes : ["Fuel"]).map((ft) => ({ fuelType: ft, percentage: "" }))
    );
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    const updateFuel = (idx, value) => {
        setStartFuel((prev) => prev.map((f, i) => (i === idx ? { ...f, percentage: value } : f)));
        setErrors((prev) => ({ ...prev, fuel: { ...(prev.fuel || {}), [idx]: null } }));
    };

    const validate = () => {
        const next = {
            startKm: odometerError(startKm, { label: "Start odometer", floor: currentKm, floorLabel: "the car's recorded reading" }),
            fuel: fuelRowsErrors(startFuel),
        };
        setErrors(next);
        return firstError(next);
    };

    const submitStartTrip = async () => {
        // Same rules as the API (odometer whole km, not below the car's
        // recorded reading; every fuel level 0-100) shown next to the field.
        const problem = validate();
        if (problem) { toast.error(problem); return; }
        const fuelPayload = startFuel.map((f) => ({ fuelType: f.fuelType, percentage: Number(f.percentage) }));

        setSubmitting(true);
        const response = await Handler({
            method: "post",
            url: `/admin/booking/trip/start/${bookingId}`,
            data: {
                startKm: Number(startKm),
                startFuel: fuelPayload,
            },
        });
        setSubmitting(false);
        if (response?.success) {
            toast.success("Trip started");
            onStarted?.();
            onClose?.();
        } else {
            toast.error(response?.data?.message || "Could not start this trip");
        }
    };

    return (
        <>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Start Trip</h5>
                            <button type="button" className="btn-close" onClick={onClose} disabled={submitting}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label small">Start odometer (km)</label>
                                <NumberField
                                    min={currentKm ?? 0}
                                    max={RULES.ODOMETER_MAX}
                                    className={`form-control${invalidClass(errors.startKm)}`}
                                    value={startKm}
                                    onChange={(v) => { setStartKm(v); setErrors((prev) => ({ ...prev, startKm: null })); }}
                                    disabled={submitting}
                                    aria-invalid={!!errors.startKm}
                                />
                                {errors.startKm && <div className="invalid-feedback">{errors.startKm}</div>}
                                {currentKm !== undefined && currentKm !== null && (
                                    <div className="form-text">Car's recorded odometer is {currentKm} km - start reading can't be lower than this.</div>
                                )}
                            </div>
                            <div className="fw-semibold small mb-2">Start fuel level</div>
                            <div className="row g-2 mb-2">
                                {startFuel.map((f, i) => (
                                    <div className="col-6" key={f.fuelType + i}>
                                        <label className="form-label small"><span className="text-capitalize">{f.fuelType}</span> % <span className="text-muted">(0 to 100)</span></label>
                                        <NumberField
                                            min={0}
                                            max={100}
                                            className={`form-control${invalidClass(errors.fuel?.[i])}`}
                                            value={f.percentage}
                                            onChange={(v) => updateFuel(i, v)}
                                            disabled={submitting}
                                            aria-invalid={!!errors.fuel?.[i]}
                                        />
                                        {errors.fuel?.[i] && <div className="invalid-feedback">{errors.fuel[i]}</div>}
                                    </div>
                                ))}
                            </div>
                            <div className="form-text">FASTag balance is fetched automatically from Surepass - it doesn't need to be entered here.</div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={submitting}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-success" onClick={submitStartTrip} disabled={submitting}>
                                {submitting ? "Starting..." : "Start Trip"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

export default StartTripModal;
